// extracted by mini-css-extract-plugin
export default {"divider":"SidebarDivider_divider__7jAR3"};